"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isPromiseLike_1 = __importDefault(require("./isPromiseLike"));
function isPromise(obj) {
    return isPromiseLike_1.default(obj) && typeof obj.then === "function";
}
exports.default = isPromise;
